import Styles from './FilesTable.module.scss'
import { Skeleton } from 'antd'
import cx from 'classnames'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props {
  loadingCellWidth?: number
  mainLoadingCellWidth?: number | string
  count?: number
  isInitialLoad?: boolean
  extraColumns?: number
}

const LoadingRow = ({ loadingCellWidth = 186, mainLoadingCellWidth = 'auto', extraColumns }: Props) => {
  const { isMobile, isMobileMd } = useResponsiveDesign()

  return (
    <div className={Styles.loadingRow}>
      <div className={Styles.skeletonWrapper}>
        <Skeleton
          active
          avatar={{ shape: 'circle', size: 32 }}
          paragraph={{ rows: 1, width: mainLoadingCellWidth }}
          title={false}
        />
      </div>
      {!isMobile && (
        <div style={{ minWidth: loadingCellWidth + 8 }}>
          <Skeleton active paragraph={{ rows: 1, width: 120 }} title={false} />
        </div>
      )}
      {!isMobileMd && (
        <div style={{ minWidth: loadingCellWidth + 8 }}>
          <Skeleton active paragraph={{ rows: 1, width: 120 }} title={false} />
        </div>
      )}
      {Array.from(Array(extraColumns)).map((_, i) => (
        <div style={{ minWidth: loadingCellWidth + 8 }} key={i}>
          <Skeleton active paragraph={{ rows: 1, width: 120 }} title={false} />
        </div>
      ))}
    </div>
  )
}

export const LoadingRows = ({
  loadingCellWidth,
  isInitialLoad,
  count = 3,
  mainLoadingCellWidth = 'auto',
  extraColumns = 0,
}: Props) => (
  <div className={cx(Styles.loadingRows, { [Styles.isInitialLoad]: isInitialLoad })}>
    {Array.from(Array(count)).map((_, i) => (
      <LoadingRow
        key={i}
        loadingCellWidth={loadingCellWidth}
        mainLoadingCellWidth={mainLoadingCellWidth}
        extraColumns={extraColumns}
      />
    ))}
  </div>
)
